export function getInitialSegmentsState(segments) {
    const initialState = {};
    segments.forEach(segment => {
        initialState[segment.groupId] = {
            selectedDate: undefined,
            isSelected: false
        };
    });
    return initialState;
}
